import type { SVGProps } from 'react';

/**
 * Widget — Card mit Sparkline.
 *
 * Domain-spezifischer Ersatz fuer `LayoutGrid` aus lucide-react. Symbolisiert
 * eine einzelne Kachel mit visualisierten Daten — naeher am Konzept "Widget"
 * als ein generischer Grid.
 */
export function WidgetIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <path d="M6 16 L9 13 L12 15 L15 11 L18 13" />
    </svg>
  );
}
